import { memo, useMemo } from 'react'
import { createPortal } from 'react-dom'
import ReactTooltip from 'react-tooltip'
import { useMemoTranslation } from '@/hooks/useMemoTranslation'
import styles from './TOCMenuTooltip.module.scss'

type Props = {
  code: string
}

export const TOCMenuTooltip = memo(({ code }: Props) => {
  const { i18n } = useMemoTranslation()
  const isRTL = i18n.dir() === 'rtl'
  const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1

  const offset = useMemo(() => ({ top: 0, ...(isRTL ? { left: 10 } : { right: 10 }) }), [isRTL])

  return createPortal(
    <ReactTooltip
      id={`toc tooltip ${code}`}
      className={styles.tooltip}
      effect={isSafari ? 'float' : 'solid'}
      place={isRTL ? 'left' : 'right'}
      offset={offset}
    />,
    document.body,
  )
})
